import { useEffect, useRef } from 'react';
import { useAuth } from '../../../hooks/useAuth';
import { syncPublicDirectoryTeamSlug } from '../../../utils/publicCollectionSync';
import { useUserTeam } from './useUserTeam';

/**
 * Keep `publicDirectory/{slug}.teamSlug` aligned with the signed-in user's team
 * so other visitors can see the affiliation on their public profile.
 */
export function useTeamDirectorySync() {
  const { user } = useAuth();
  const { team, loading } = useUserTeam(user?.teamId);
  const lastWritten = useRef<string | null>(null);

  useEffect(() => {
    if (!user?.slug) {
      lastWritten.current = null;
      return;
    }

    // Wait until team membership is resolved so we don't briefly clear a valid tag.
    if (user.teamId && loading) return;

    const next = team?.slug?.trim().toLowerCase() || null;
    const key = `${user.slug}:${next ?? ''}`;
    if (lastWritten.current === key) return;
    lastWritten.current = key;

    void syncPublicDirectoryTeamSlug({ slug: user.slug, teamSlug: next }).catch((err) => {
      lastWritten.current = null;
      console.warn('[useTeamDirectorySync] failed', err);
    });
  }, [user?.slug, user?.teamId, team?.slug, loading]);
}
